import './styles.scss';

import { useIntl, FormattedMessage } from 'react-intl';

import { EuiSwitch, EuiFieldNumber, EuiFormControlLayoutDelimited, EuiSwitchEvent } from '@elastic/eui';
import { Button } from '../Button';
import { ClearButton } from '../ClearButton';
import { ChangeEvent } from 'react';

export interface CalculatePriceFiltersProps {
  onClear: () => void;

  excludeYourAds: boolean;
  onExcludeYourAds: (checked: EuiSwitchEvent) => void;

  month: string | number | undefined;
  onChangeMonth: (month: string) => void;

  year: string | number | undefined;
  onChangeYear: (year: string) => void;

  km: string | number | undefined;
  onChangeKm: (km: string) => void;

  onCalculatePrice: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
}

export const CalculatePriceFilters = ({
  onClear,
  excludeYourAds,
  onExcludeYourAds,
  month,
  onChangeMonth,
  year,
  onChangeYear,
  km,
  onChangeKm,
  onCalculatePrice,
  isDisabled = false,
  isLoading,
}: CalculatePriceFiltersProps): JSX.Element => {
  const intl = useIntl();

  return (
    <div className={`calculatePriceFilters_wrapper ${isDisabled ? 'disabled' : ''}`}>
      <div className="calculatePriceFilters_firstGroup">
        <ClearButton onClick={onClear} />
      </div>
      <div className="calculatePriceFilters__secondGroup">
        <div className="filter">
          <label>
            <FormattedMessage id="vehicle-registration-date" defaultMessage="Data di immatricolazione" />
          </label>
          <EuiFormControlLayoutDelimited
            compressed={true}
            icon="calendar"
            startControl={
              <input
                type="number"
                min="1"
                max="12"
                onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                  onChangeMonth(e.target.value);
                }}
                value={month}
                placeholder={intl.formatMessage({ id: 'month' })}
                className="euiFieldNumber"
                disabled={isDisabled}
              />
            }
            delimiter="/"
            endControl={
              <input
                type="number"
                min="1900"
                onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                  onChangeYear(e.target.value);
                }}
                value={year}
                placeholder={intl.formatMessage({ id: 'year' })}
                className="euiFieldNumber"
                disabled={isDisabled}
              />
            }
          />
        </div>
        <div className="filter">
          <label>
            <FormattedMessage id="enter-km" defaultMessage="Inserire Km" />
          </label>
          <EuiFieldNumber
            name="km"
            placeholder={intl.formatMessage({ id: 'enter-km' })}
            icon="metricbeatApp"
            onChange={(e: ChangeEvent<HTMLInputElement>): void => {
              onChangeKm(e.target.value);
            }}
            value={km}
            aria-label="Km filter"
            compressed={true}
            disabled={isDisabled}
          />
        </div>
        <EuiSwitch
          disabled={isDisabled}
          label={intl.formatMessage({ id: 'exclude-your-ads' })}
          checked={excludeYourAds}
          onChange={onExcludeYourAds}
          compressed
        />
        <Button isLoading={isLoading} onClick={!isDisabled ? onCalculatePrice : (): void => {}} big>
          <FormattedMessage id="calculate-price" />
        </Button>
      </div>
    </div>
  );
};
